import type { TrainingLessonSpecific } from './trainingLessonUi';

export const teacher1DutiesEs: TrainingLessonSpecific = {
  intro:
    'El Maestro no es "teacher de clase", sino el oficio del Sacerdocio Aarónico: ayudar a los miembros a vivir el Evangelio, fortalecer, y apoyar la reverencia y el orden. Menos "yo paso" y más "yo cuido".',
  objectives: [
    'Entender el propósito del oficio de Maestro en el Sacerdocio Aarónico.',
    'Identificar deberes clave: fortalecer, velar, y ayudar a que haya reverencia y orden.',
    'Aprender a corregir con amor (sin humillar ni discutir).',
    'Practicar preparación espiritual para servir (oración, dignidad, ejemplo).',
    'Crear un plan semanal simple para cumplir deberes (casa + Iglesia).',
  ],
  briefHeading: 'Los deberes del Maestro en breve',
  briefBody:
    'Un Maestro fortalece a los miembros, vela por la Iglesia con caridad (no como policía), y ayuda a mantener reverencia y orden. Corrige con mansedumbre, se prepara con oración y ejemplo, y planifica el servicio en casa y en la capilla.',
  scriptures: [
    { ref: 'DyC 20:53–59', text: 'Deberes de maestros y diáconos: velar por la Iglesia, estar con ella.' },
    { ref: 'DyC 107:86', text: 'Deberes del Maestro: ayudar y ministrar.' },
    { ref: 'Moroni 6:4', text: 'Fortalecer a los miembros y nutrirlos con la palabra.' },
    { ref: 'Gálatas 6:1', text: 'Restaurar al tal con espíritu de mansedumbre.' },
    { ref: 'DyC 121:41–42', text: 'Persuasión, longanimidad, benignidad, amor sincero.' },
  ],
  didYouKnow: [
    'Un Maestro "vela" por la Iglesia: no es vigilancia rara, es cuidado espiritual y apoyo.',
    'Corregir "con amor" no es debilidad: es liderazgo con dominio propio.',
  ],
  practiceItems: [
    'Preparación: orar 1 minuto antes de la reunión para pedir reverencia y caridad',
    'Observar sin criticar: identificar 1 necesidad real (alguien solo, alguien nuevo, alguien distraído)',
    'Hacer 1 acto de apoyo: saludar, ayudar a ubicar himno, acomodar sillas, guiar con respeto',
    'Practicar corrección con amor: escribir 2 frases suaves para invitar al orden (ej.: "Vamos a ayudar con reverencia", "Te acompaño afuera un momento")',
    'Servicio en casa: hacer 1 responsabilidad sin que te lo pidan (con buena actitud)',
    '"Mini-reporte personal": al final del día, escribir 1 línea: "Hoy ayudé a ____ y aprendí ____."',
  ],
  reflectionQuestions: [
    '¿Qué significa para mí "velar por la Iglesia" sin sentirme "policía"?',
    '¿Cómo reacciono cuando alguien me corrige? ¿Puedo corregir mejor de lo que me gusta que me corrijan?',
    '¿Qué haré esta semana para ser un ejemplo de reverencia y servicio?',
  ],
  actionText:
    'Plan de cuidado: elige 1 persona (o 1 situación) que vas a apoyar esta semana (ej.: saludar a alguien nuevo, ayudar a un hermano mayor, apoyar a tu familia en casa sin quejarte).',
};
